import { render, staticRenderFns } from "./magiczoom.vue?vue&type=template&id=3f6cc821"
import script from "./magiczoom.vue?vue&type=script&lang=js"
export * from "./magiczoom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Entwicklung/plentyDev2025/7843/112/Servershop5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f6cc821')) {
      api.createRecord('3f6cc821', component.options)
    } else {
      api.reload('3f6cc821', component.options)
    }
    module.hot.accept("./magiczoom.vue?vue&type=template&id=3f6cc821", function () {
      api.rerender('3f6cc821', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/servershop/magiczoom.vue"
export default component.exports